import { Link } from "react-router-dom";
import { ArrowLeft, Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F8F9] p-6" data-testid="not-found-page">
      <div className="w-full max-w-lg text-center fade-up">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-[#0F7B85]/10 text-[#0F7B85] mb-6">
          <Compass className="w-10 h-10" strokeWidth={1.6}/>
        </div>
        <div className="font-mono text-sm tracking-[0.3em] text-slate-400 uppercase">Errore 404</div>
        <h1 className="font-display text-4xl sm:text-5xl text-[#0F7B85] mt-3">Pagina non trovata</h1>
        <p className="mt-5 text-slate-600 leading-relaxed">
          La pagina che stai cercando potrebbe essere stata spostata, rimossa o non è mai esistita.
          Nessun problema: torna alla home oppure accedi alla tua area personale.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="bg-[#0F7B85] text-white hover:bg-[#0A5C64] rounded-lg px-6 py-3 font-medium inline-flex items-center justify-center gap-2 transition-colors"
          >
            <ArrowLeft className="w-4 h-4"/> Torna alla home
          </Link>
          <Link
            to="/login"
            className="border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 rounded-lg px-6 py-3 font-medium transition-colors"
          >
            Accedi al tuo account
          </Link>
        </div>
        <div className="mt-12 pt-6 border-t border-slate-200 text-xs text-slate-400 leading-relaxed">
          BeSafe Broker s.r.l. · P.IVA <span className="font-mono">07093890825</span> · RUI <strong>B000725320</strong> · Vigilanza IVASS
        </div>
      </div>
    </div>
  );
}
